module.exports = __webpack_public_path__ + "img/bg_user_profile_small.5b9fef7e.jpg";